import styled from 'styled-components';
import magnifying from '../../../img/svg/magnifying-glass.svg';
import MaskedInput from 'react-text-mask';

export const ContainerInput = styled.div`
  width: 17vw;

  &:after {
    content: url(${magnifying});
    width: .5rem;
    height: .5rem;
    position: absolute;
    left: 60%;
  }
`;

export const Input = styled.input`
  width: 100%;
  outline-width: 0;
  font-size: .9rem;
  font-family: 'Open Sans';
  background: transparent;
  border: transparent;
  border-bottom: 1px solid ${props => props.theme['color_border-gray-secondary']};
  padding-left: 8px;
  color: ${props => props.theme.color_gray};

  &:focus {
    background: ${props => props.theme.color_white};
  }
`;

export const DateInput = styled(MaskedInput)`
  width: 100%;
  box-sizing: border-box;
  outline: none;
  font-size: 0.8rem;
  font-family: 'Open Sans', system-ui, sans-serif;
  background: #f8f9fb;
  border: 1px solid rgba(21, 43, 78, 0.12);
  border-radius: 8px;
  padding: 8px 10px;
  color: #152b4e;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;

  &:focus {
    background: #fff;
    border-color: #152b4e;
    box-shadow: 0 0 0 3px rgba(21, 43, 78, 0.1);
  }

  ::placeholder {
    color: #8b95a5;
  }
`;

export const DateContainerInput = styled.div`
  width: 118px;
  min-width: 100px;
  flex-shrink: 0;
  display: inline-block;

  @media (max-width: 500px) {
    width: 100%;
    max-width: 140px;
  }
`;

export const FilterContainerInput = styled.div`
  flex: 1;
  min-width: 0;
  display: block;
`;

export const FilterIcon = styled.img`
  height: 0.95rem;
  opacity: 0.85;
  flex-shrink: 0;
`;

export const FilterInput = styled.input`
  width: 100%;
  box-sizing: border-box;
  outline: none;
  font-size: 0.875rem;
  font-family: 'Open Sans', system-ui, sans-serif;
  background: #f8f9fb;
  border: 1px solid rgba(21, 43, 78, 0.12);
  border-radius: 8px;
  padding: 9px 12px;
  color: #152b4e;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;

  &:focus {
    background: #fff;
    border-color: #152b4e;
    box-shadow: 0 0 0 3px rgba(21, 43, 78, 0.12);
  }

  ::placeholder {
    color: #8b95a5;
  }
`;

export const FilterButton = styled.button`
  cursor: pointer;
  margin-left: 4px;
  padding: 9px 20px;
  border: none;
  border-radius: 10px;
  font-family: 'Open Sans', system-ui, sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #fff;
  background: ${({$onBlue}) => (
    $onBlue
      ? `linear-gradient(
          165deg,
          #ffc56b 0%,
          #ff9f2e 18%,
          #ff7200 45%,
          #e85d00 72%,
          #c44a00 100%
        )`
      : `linear-gradient(180deg, #1a3d66 0%, #152b4e 55%, #122845 100%)`
  )};
  box-shadow: ${({$onBlue}) => (
    $onBlue
      ? `0 2px 8px rgba(255, 114, 0, 0.35), inset 0 1px 0 rgba(255, 255, 255, 0.25)`
      : `0 1px 0 rgba(255, 255, 255, 0.12) inset, 0 2px 6px rgba(21, 43, 78, 0.25)`
  )};
  transition: filter 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;

  &:hover {
    filter: brightness(1.05);
    box-shadow: ${({$onBlue}) => (
      $onBlue
        ? `0 4px 14px rgba(255, 114, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.3)`
        : `0 1px 0 rgba(255, 255, 255, 0.15) inset, 0 4px 14px rgba(21, 43, 78, 0.35)`
    )};
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const MobileFilterButton = styled.button`
  @media (min-width: 801px) {
    display: none;
  }

  @media (max-width: 800px) {
    position: relative;
    top: auto;
    right: auto;
    flex: 1;
    min-width: 0;
    max-width: 100%;
    z-index: 2;
  }

  cursor: pointer;
  padding: 8px 16px;
  border: none;
  border-radius: 10px;
  font-family: 'Open Sans', system-ui, sans-serif;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #fff;
  background: ${({$onBlue}) => (
    $onBlue
      ? `linear-gradient(
          165deg,
          #ffc56b 0%,
          #ff7200 45%,
          #c44a00 100%
        )`
      : `linear-gradient(180deg, #1a3d66 0%, #152b4e 55%, #122845 100%)`
  )};
  box-shadow: ${({$onBlue}) => (
    $onBlue ? `0 2px 8px rgba(255, 114, 0, 0.35)` : `0 2px 8px rgba(21, 43, 78, 0.28)`
  )};
  transition: filter 0.18s ease, transform 0.18s ease;

  &:hover {
    filter: brightness(1.05);
    transform: translateY(-1px);
  }
`;

export const FilterText = styled.span`
  color: #5c6a7a;
  font-size: 12px;
  font-family: 'Open Sans', system-ui, sans-serif;
  flex-shrink: 0;
`;